export const mediaQueries = {
  smallMax: 480,
  mediumMax: 768,
  largeMin: 769,
  xlargeMin: 1200
};
